<template>
  <div>
    <div :class="{'legenda-container': !legenda}">
      <div v-if="!legenda" class="legenda-info">
        <div>
          <div class="legenda-wrapper">
            <div>
              <div class="sphere green-sphere"></div>
            </div>
            O NCM selecionado possui vínculo com este CNAE.
          </div>
          <div class="legenda-wrapper">
            <div>
              <div class="sphere yellow-sphere"></div>
            </div>
            Outra NCM da lista possui vínculo com este CNAE.
          </div>
          <div class="legenda-wrapper">
            <div>
              <div class="sphere red-sphere"></div>
            </div>
            Nenhuma NCM da lista possui vinculo com este CNAE.
          </div>
        </div>
      </div>
      <div class="legenda-info">
        <div class="legenda-info-box">
          <font-awesome-icon class="legenda-exclamacao" icon="exclamation-circle" />
          As correlações dos códigos CNAE comerciais e industriais com os códigos NCM foram
          desenvolvidos com base na linha interpretativa adotada pela Econet e não representam
          previsões expressas em legislação.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LegendaCompreende",
  props: {
    legenda: Boolean
  }
};
</script>

<style lang="scss" scoped>
.sphere {
  height: 14px;
  width: 14px;
  margin: 2px 10px 2px 0;
  border-radius: 50%;
  background: #28a745;
  box-shadow: 2px 2px 4px #d4d4d486;
}
.green-sphere {
  background: #28a745;
}
.yellow-sphere {
  background: #ffc107;
}
.red-sphere {
  background: #dc3545;
}
.legenda-wrapper {
  display: flex;
  margin-bottom: 3px;
}
.legenda-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
}
.legenda-info {
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // align-items: center;
}
.legenda-exclamacao {
  height: 14px;
  width: 14px;
  margin: 2px 7px 0 0;
}
.legenda-info-box {
  // text-align: justify;
  display: flex;
  border: 1px solid var(--cinza03);
  background: #f9f9f9;
  padding: 5px 10px;
  border-radius: 10px;
}
</style>
